import { render, staticRenderFns } from "./EditImageDialog.vue?vue&type=template&id=28152334"
import script from "./EditImageDialog.vue?vue&type=script&lang=js"
export * from "./EditImageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports